// @flow

export default class RichError extends Error {
  metadata: Object;

  constructor(message: string, metadata: Object) {
    super(message);
    this.name = 'RichError';
    this.metadata = metadata;
  }
}
